import { useAppSelector } from "@/state/redux/hooks";
import { selectMe } from "@/state/redux/slices/ui";

import Landing from "./landing/Landing";
import Records from "./Records";

/**
 * What "/" is, which depends on whether anyone is reading it.
 *
 * Signed in it is the all-collections timeline, as it has always been. Signed
 * out it used to be that same timeline with nothing in it — `Records` has no
 * user to load for and renders "No records" inside the full three-panel shell,
 * which is a tool with the lights off, not an invitation. The landing page
 * takes that slot instead.
 *
 * A gate rather than a redirect to some /welcome route: the two are the same
 * URL to everyone who links to it, and signing in from the landing page sets
 * `me`, flips this, and lands the new account on its own timeline without a
 * navigation.
 *
 * No flash of the wrong one: `main.tsx` awaits `checkAuthorization()` before it
 * mounts React, so `me` is already settled on the first render.
 *
 * `useAppChrome` decides the same question for the frame around this.
 */
export default function Home() {
  const me = useAppSelector(selectMe);

  return me ? <Records /> : <Landing />;
}
